export enum INTERCOM_SLOT {
  "articleBottom1" = "articleBottom1",
  "articleBottom2" = "articleBottom2",
  "articleRightRail1" = "articleRightRail1",
  "articleRightRail2" = "articleRightRail2",
  "articleRightRail3" = "articleRightRail3",
}

export enum ABBA_PLATFORM {
  "article" = "article",
  "homepage" = "homepage",
}

export const INTERCOM_SLOTS = {
  [ABBA_PLATFORM.article]: [
    INTERCOM_SLOT.articleBottom1,
    INTERCOM_SLOT.articleBottom2,
    INTERCOM_SLOT.articleRightRail1,
    INTERCOM_SLOT.articleRightRail2,
    INTERCOM_SLOT.articleRightRail3,
  ],
};

export const MILLISECONDS_PER_SECOND = 1000;

export const SECONDS_PER_MINUTE = 60;

export const MINUTES_PER_HOUR = 60;

export const MILLISECONDS_PER_DAY = 86400 * MILLISECONDS_PER_SECOND;

export const MAX_RESOURCE_AGE_DEFAULT = MILLISECONDS_PER_DAY * 14;

export const VALID_REGEX = {
  dateString: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/,
  email: /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
  id: /^(\w|-|\/)+$/,
  ids: /^(\w|-|;|\/)+$/,
  objectKey: /^(\w|.)+$/,
  objectValue: /^(\w|-|\/)+$/,
  security: /^[a-zA-Z0-9%]+:[a-zA-Z%]+$/,
  slug: /^(\w|-|\/)+$/,
};
